interface ErrorWithData {
  data: {
    errorMessage: string;
  };
}

export function getErrorMessage(error: unknown) {
  if (error && typeof error === "object" && typeof Reflect.get(error, "data") === "object") {
    const errorWithData = error as ErrorWithData;
    return errorWithData.data.errorMessage;
  }
  if (error && error instanceof Error) {
    return error.message;
  }
  return JSON.stringify(error);
}
